export default __webpack_public_path__ + "static/media/journal-1-slideout.2e124f87.jpg";